












import Vue from "vue";
import iwInputGroupStepper from "@/encoding/components/buildingBlocks/InputGroupStepper.vue";

export default Vue.extend({
    components: {
        iwInputGroupStepper: iwInputGroupStepper
    },
    data: function() {
        return {
            pathInStore: "property.building.floorCount"
        };
    },
    computed: {
        floorCount: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY","GARAGE", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
    },
    methods: {
        updateValue: function(floorCount: number): void {
            if (floorCount == 0 && this.$store.getters["FormModule/getValue"](this.pathInStore) != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": floorCount});
            }
        }
    }
});

